//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Clipboard from 'clipboard';
import CouponCard from '@/components/CouponCard';
import XButton from 'vux/src/components/x-button';
import { mapState } from 'vuex';
import { setTitle } from '@/utils';
import { roleTypeMap } from '@/utils/map';
import env from '@/utils/env';
import UBT from '@/utils/ubt';
import copyImg from '@/assets/images/activity/copy.png';
import downloadImg from '@/assets/images/activity/download.png';

export default {
  components: {
    CouponCard,
    XButton,
  },
  data() {
    return {
      activityId: '',
      roleType: '',
      sourceId: '',
      shareUrl: '',
      isAlipayClient: env.isAlipayClient,
      copyImg,
      downloadImg,
    };
  },

  computed: {
    UIconfig() {
      switch (+this.roleType) {
        case 1:
          return {
            url: this.activity.leaderUrl,
            color: this.activity.leaderColour
          };
        case 2:
          return {
            url: this.activity.memberUrl,
            color: this.activity.memberColour
          };
        default:
          return {
            url: this.activity.couponUrl,
            color: this.activity.couponColour
          };
      }
    },
    activityRules() {
      return (this.activity.activityRule || '').split('<br>') || [];
    },
    ...mapState({
      activity: state => state.activity.activity,
      mobile: state => state.user.loginResult.mobile
    })
  },

  mounted() {
    const { activityId, roleType, sourceId } = this.$route.query;
    if (
      +roleType !== +this.$store.state.user.loginResult.roleType
        || +activityId !== +this.$store.state.user.loginResult.activityId
        || (this.$store.state.user.loginResult.sourceId
         && sourceId !== this.$store.state.user.loginResult.sourceId)
    ) {
      this.$router.replace({
        name: 'login',
        query: this.$route.query
      });
      this.$throw(new Error('登录已失效，请重新登录'));
      return;
    }
    UBT.pageView({
      pageId: 'H5_换电_用户领券页已登录状态',
      additionValue: env.isWeixin ? '微信' : '其他',
      additionType: '展示终端',
    });
    this.init();
  },

  methods: {
    formatMobile(mobile) {
      if (!mobile) return '-';
      const temp = `${mobile}`.split('');
      temp.splice(3, 4, ['****']);
      return temp.join('');
    },
    init() {
      this.initState();
    },
    initState() {
      const { activityId, sourceId } = this.$route.query;
      // let { roleType = '4' } = this.$route.query;
      if (!activityId) {
        throw new Error('活动不存在');
      }
      const roleType = '4';
      Object.assign(this, { activityId, roleType, sourceId });
      this.getActivity(activityId, roleType);
      this.shareUrl = `${window.location.origin + window.location.pathname}#/login?autologin=1&activityId=${activityId}&sourceId=${sourceId}&roleType=${roleTypeMap.user}`;
    },
    async getActivity(activityId, roleType) {
      await this.$store.dispatch('getActivity', { activityId, roleType });
      setTitle(this.activity.activityName);
    },
    downloadApp() {
      UBT.clickButton({
        buttonName: 'H5_换电_用户领券页已登录状态_打开哈啰出行APP',
        pageId: 'H5_换电_用户领券页已登录状态',
      });
      if (env.isWeibo || env.isWeixin || env.isQQ) {
        window.location.href = 'https://at.umtrack.com/onelink/CuiKfy';
      } else {
        window.location.href = 'https://c3x.me/bike.html?redirectUrl=hellobike%3a%2f%2fhellobike.com%2fmain%3fbikeType%3d10';
      }
    },
    copy() {
      UBT.clickButton({
        buttonName: 'H5_换电_用户领券页已登录状态_复制链接',
        pageId: 'H5_换电_用户领券页已登录状态',
      });
      const clipboard = new Clipboard('.tag-read');
      clipboard.on('success', () => {
        this.$vux.toast.show({
          type: 'text',
          width: 'auto',
          text: '复制成功',
        });
      });
      clipboard.on('error', () => {
        this.$vux.toast.show({
          type: 'text',
          width: 'auto',
          text: '复制失败',
        });
      });
    },
    goShare() {
      UBT.clickButton({
        buttonName: 'H5_换电_用户领券页已登录状态_生成图片',
        pageId: 'H5_换电_用户领券页已登录状态',
      });
      this.$router.push({
        name: 'share',
        query: {
          roleType: this.roleType,
          activityId: this.activityId,
          sourceId: this.sourceId
        }
      });
    }
  }
};
